import React from 'react'
import FormCss from "./fom.module.scss";


function TextDescription(props) {
  return (
    <p className={`${FormCss.tabclix__form_desc}`}>{props.label}</p>
  )
}

export default TextDescription